<section class="empty-state-shell">
  <div class="empty-state-card">
    <h2>{{ title() }}</h2>
    @if (hint()) {
      <p>{{ hint() }}</p>
    }
    <ng-content />
  </div>
</section>
